module.exports = __webpack_public_path__ + "static/media/man2.9af98f57.jpg";